import { Directive, ElementRef, Input, OnInit, inject } from '@angular/core';
import { PopoverComponent } from '../popover.component';

@Directive({
  selector: '[glxyPopover]',
  exportAs: 'glxyPopover',
  standalone: false,
})
export class GalaxyPopoverDirective implements OnInit {
  /** Passed in reference of the popover */
  @Input('glxyPopover') popover?: PopoverComponent;

  private readonly elementRef = inject(ElementRef);

  ngOnInit(): void {
    this.popover?.setOrigin(this.elementRef);
  }
}
